import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { auth } from 'firebaseui';
import '../node_modules/firebaseui/dist/firebaseui.css';
import { saveQuestionsLocal, fetchQuestions, getFirstQuestionIndex } from 'lib'
import QuizDB from 'quizdb'
import { message } from "antd";

const firebaseConfig = {
  apiKey: "AIzaSyCywlQI2AxIWUITQLtdOtM0dsv3KoHHNJQ",
  authDomain: "quiz-composer.firebaseapp.com",
  projectId: "quiz-composer",
  storageBucket: "quiz-composer.appspot.com",
  messagingSenderId: "864265241216",
  appId: "1:864265241216:web:4f8b7c167a378466481c65",
  measurementId: "G-9L313HFEEP"
};

firebase.initializeApp(firebaseConfig);
const ui = new auth.AuthUI(firebase.auth());

function __getAccessToken() {
	const accessToken = sessionStorage.getItem('access_token');
	return accessToken;
}

function __setToken(accessToken) {
	sessionStorage.setItem('access_token', accessToken);
}

function __setAuth(auth) {
	sessionStorage.setItem('auth', JSON.stringify(auth));
}

function __consumeOnAfterAuthListeners() {
	while (onAfterAuthListeners.length > 0) {
		onAfterAuthListeners.shift()();
	}
}

function __consumeOnAfterQuestionsLoadedListeners() {
	while (onAfterQuestionsLoadedListeners.length > 0) {
		onAfterQuestionsLoadedListeners.shift()();
	}
}

function __onAfterAuth() {
	const onSuccess = (questions) => {
		saveQuestionsLocal(questions) // do we need to save after loading?
		__consumeOnAfterQuestionsLoadedListeners()
	}
	const onError = (error) => message('load questions from db')
	QuizDB.loadQuestions(onSuccess, onError);
}

const onAfterAuthListeners = Array()
const onAfterQuestionsLoadedListeners = Array()

export default class Auth {
	static initDropinAuthUI(callback) {
		Auth.onAfterAuthListener(() => callback(true))

		ui.start('#firebaseui-auth-container', {
		  signInOptions: [
		    firebase.auth.EmailAuthProvider.PROVIDER_ID
		  ],
		  callbacks: {
		    signInSuccessWithAuthResult: function(authResult, redirectUrl) {
		    	console.log('auth successful', authResult);
		    	__setAuth(authResult)
		    	const accessToken = authResult.user.accessToken ||
	    												authResult.user.multiFactor.user.accessToken ||
		    											authResult.user.accessToken ||
		    											authResult.user._delegate	.accessToken;
		    	__setToken(accessToken);
					__consumeOnAfterAuthListeners()
		      return false;
		    },
		  },
		});
	}

	static isAuth() {
		const accessToken = __getAccessToken();
		return accessToken ? true : false;
	}

	static getAuth() {
		const auth = JSON.parse(sessionStorage.getItem('auth'));
		return auth;
	}

	static onAfterAuthListener(callback) {
		onAfterAuthListeners.push(callback)
		if (Auth.isAuth()) {
			__consumeOnAfterAuthListeners()
		}
	}

	static onAfterQuestionsLoadedListener(callback) {
		onAfterQuestionsLoadedListeners.push(callback)
		const questions = fetchQuestions()
		if (getFirstQuestionIndex(questions) > -1) {
			__consumeOnAfterQuestionsLoadedListeners()
		}
	}

	static deAuth() {
		sessionStorage.removeItem('auth')
		sessionStorage.removeItem('access_token')
	}
}
